import { createState, State } from '@hookstate/core';
import { createContext } from 'react';

export const disabledReasonContext = createContext<State<Record<string, string>>>(createState<Record<string, string>>({}));
